import { render, staticRenderFns } from "./ItemRow.vue?vue&type=template&id=7c46a12c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./ItemRow.vue?vue&type=script&lang=ts"
export * from "./ItemRow.vue?vue&type=script&lang=ts"
import style0 from "./ItemRow.vue?vue&type=style&index=0&id=7c46a12c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c46a12c",
  null
  
)

export default component.exports